import React, { useEffect, useState, useMemo, useCallback, useRef } from 'react';
import { Button, Paper, Box, TextField, Autocomplete } from '@mui/material';
import { AgGridReact } from 'ag-grid-react';
import { ModuleRegistry, AllCommunityModule, themeQuartz } from 'ag-grid-community';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, BarChart, Bar, LabelList } from 'recharts';
import { useGetCRMDashboardMutation, useGetSMSContentMutation } from '../../services/consumer';
import { usePhuTranMutation } from '../../services/home';
import LoadingPage from '../loadingPage';
import AlertSnackbar from '../alertSnackbar';
import "react-day-picker/style.css";
import moment from 'moment';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import DateRange from '../tools/daterange';
import AutocompleteWithAll from '../tools/autocompleteWithAll';
const API_URI = process.env.REACT_APP_API_URI;

export default function TableResult(props) {
  const [phutran, phutranResult] = usePhuTranMutation();
  const [dataLoaded, setDataLoaded] = useState([]);
  const [columns, setCoumns] = useState([]);
  const [gridHeight, setGridHeight] = useState(300);
  const [snackContent, setSnackContent] = useState("");
  const [range, setRange] = useState({from: moment().startOf('month'), to: moment()});
  const [viewDetail, setViewDetail] = useState(0);
  const [openImport, setOpenImport] = useState(false);
  const [smsContent, setSMSContent] = useState([]);
  const [selectedSMS, setSelectedSMS] = useState({});
  const gridRef = useRef();
  const [pinnedBottomRowData, setPinnedBottomRowData] = useState([
      { make: 'Total', model: '', TOTAL: 0 }
  ]);

  ModuleRegistry.registerModules([ AllCommunityModule ]);

  useEffect(() => {
    if(props.data?.length > 0)
      getCoumns(props.data[0]);

    handleGridHeight();
  }, [props.data]);

  const handleGridHeight = () =>{
    const divHeader = document.getElementById('divHeader');
    setGridHeight(window.innerHeight - (divHeader?divHeader.clientHeight:0) - 320);
  }

  const getDataView = async() =>{
    let result = await phutran({"type": 'exec', query: "select ID, QUERY from PHUTRAN union all select 0 ID, '' QUERY"}).unwrap();
    if(typeof result === "string")
                    result = JSON.parse(result);

    if(result.length > 0)
      getCoumns(result[0]);
    
    setDataLoaded(result);
    handleGridHeight();
  }

  const getCoumns=(item)=>{
    const cols = Object.keys(item).map((key) => {
      return {
        field: key,
        filter: true,
        cellStyle: () => ((key=="TotalGross" || key=="TotalNet")
        ?{
          display: "flex",
          alignItems: "right",
          justifyContent: "right",
          fontWeight: key=="TotalNet" ? "bold" : ""
        }:null),
        valueFormatter: params => params.data[key] && (
          (key=="PrevBill")?moment(params.data[key]).format("YYYY-MM-DD")
          :(key=="TotalGross" || key=="TotalNet")?new Intl.NumberFormat('en-US').format(params.data[key]):params.data[key]
        )
      }
    });
    setCoumns(cols);
  }

  const onGridReady = useCallback((params) => {
    gridRef.current = params.api;
  }, []);

  const getRowClass = useCallback(params => {
    if (params.node.rowIndex % 2 === 1) {
        return "grid-odd-rows";
    }
    if (params.node.rowPinned === 'bottom') {
      return "text-bold";
    }
  }, []);

  const myTheme = themeQuartz.withParams({
    // borderColor: "#9696C8",
    wrapperBorder: false,
    headerRowBorder: false,
    // rowBorder: { style: "dotted", width: 1 },
    columnBorder: { style: "dashed", color: '#9696C8' },
    headerColumnBorder: { style: 'solid', width: 1, color: '#ccc' },
  });

  const theme = useMemo(() => {
    return myTheme;
  }, []);

  return (
    <div>
      { (phutranResult.isLoading) && <LoadingPage /> }
      <TextField style={{width: '100%'}} value={props?.record?.QUERY} multiline={true} rows={10}
        onChange={props.onChangeQuery} />
      <div>
        <Paper sx={{ height: gridHeight, width: '100%', float: 'left' }}>
          <AgGridReact enableCellTextSelection={true} ensureDomOrder={true}
            rowData={props?.data}
            columnDefs={columns}
            pagination={true}
            paginationPageSize={500}
            paginationPageSizeSelector={[200, 500, 1000]}
            // pinnedBottomRowData={pinnedBottomRowData}
            getRowClass={getRowClass}
            theme={theme}
            onGridReady={onGridReady}
          />
        </Paper>
      </div>

      <AlertSnackbar message={snackContent} setSnackContent={setSnackContent}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} />
    </div>
  )
}